import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Divider, Drawer, Hidden, IconButton, Typography} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import InputIcon from '@material-ui/icons/Input';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import {SidebarNav} from './components';
import {getUserType} from '../../../../apis/api';
import { signOut } from '../../../../apis/api';

const useStyles = makeStyles(theme => ({
    drawer: {
        width: 240,
        [theme.breakpoints.up('lg')]: {
            marginTop: 64,
            height: 'calc(100% - 64px)',
        },
    },
    root: {
        backgroundColor: theme.palette.white,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: theme.spacing(2),
    },
    divider: {
        margin: theme.spacing(1, 0),
    },
    closeButton: {
        marginLeft: 'auto'
    },
    signOutButton: {
        color: theme.palette.text.primary,
        marginRight: 'auto',
        padding: 10
    },
    signOutText: {
        color: theme.palette.text.primary,
        marginLeft: theme.spacing(1),
    },
    nav: {
        marginBottom: theme.spacing(2),
    },
}));

const Sidebar = props => {
    const {open, variant, onClose, className, ...rest} = props;

    const classes = useStyles();

    const pages = [
        {
            title: 'Dashboard',
            href: '/dashboard',
            icon: <DashboardIcon/>,
            depth: 1,
        },
        {
            title: 'ECDI',
            href: '/ecdi',
            icon: <AssessmentIcon/>,
            depth: 1,
        },
        {
            title: 'Daily',
            href: '/ecdi/daily',
            icon: <ArrowRightIcon/>,
            depth: 2,
        },
        {
            title: 'Weekly',
            href: '/ecdi/weekly',
            icon: <ArrowRightIcon/>,
            depth: 2,
        },
        {
            title: 'Monthly',
            href: '/ecdi/monthly',
            icon: <ArrowRightIcon/>,
            depth: 2,
        },
        {
            title: 'Catetory',
            href: '/category/request',
            icon: <ListAltIcon/>,
            depth: 1,
        },
        {
            title: 'Request permission',
            href: '/category/request',
            icon: <ArrowRightIcon/>,
            depth: 2,
        },
        {
            title: 'Manage permission',
            href: '/category/management',
            icon: <ArrowRightIcon/>,
            depth: 2,
        },
        {
            title: 'Best',
            href: '/best',
            icon: <EqualizerIcon/>,
            depth: 1,
        },
        {
            title: 'Screenshot',
            href: '/screenshot',
            icon: <AspectRatioIcon/>,
            depth: 1,
        },
        // TODO : 미개발 메뉴 비활성화
        // {
        //     title: 'Promotion',
        //     href: '/promotion/',
        //     icon: <TimelineIcon/>,
        //     depth: 1,
        // },
        // {
        //     title: 'Monthly Frequency',
        //     href: '/promotion/frequency',
        //     icon: <ArrowRightIcon/>,
        //     depth: 2,
        // },
        {
            title: 'Account',
            href: '/account',
            icon: <AccountBoxIcon/>,
            depth: 1,
        },
    ];

    if (getUserType() !== 'ADMIN') {
        const adminPageIdx = pages.findIndex(v => v.title === '권한 관리');
        pages.splice(adminPageIdx, 1);
    }

    const handleSignOut = event => {
        event.preventDefault();

        signOut()
            .then((res) => {
                if (res.logout) {
                    window.location.href = '/sign-in';
                }
            }).catch((error) => {
                console.log(error);
            });
    };

    return (
        <Drawer
            anchor="left"
            classes={{paper: classes.drawer}}
            onClose={onClose}
            open={open}
            variant={variant}
        >
            <div
                {...rest}
                className={clsx(classes.root, className)}
            >
                <Hidden lgUp>
                    <IconButton
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </Hidden>
                <Divider className={classes.divider}/>
                <SidebarNav
                    onClick={onClose}
                    className={classes.nav}
                    pages={pages}
                />
                <Divider className={classes.divider}/>
                <IconButton
                    className={classes.signOutButton}
                    onClick={handleSignOut}
                >
                    <InputIcon/>
                    <Typography
                        variant="button"
                        className={classes.signOutText}
                    >
                        SIGN OUT
                    </Typography>
                </IconButton>
            </div>
        </Drawer>
    );
};

Sidebar.propTypes = {
    className: PropTypes.string,
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    variant: PropTypes.string.isRequired,
};

export default Sidebar;
